/**
 * Иконки прототипа (03_dorixona_monorepo/docs/ui/index.html) одним спрайтом.
 * Спрайт рисуется один раз в корне приложения, дальше иконки берутся по имени:
 * <Icon name="i-cart" />. Цвет наследуется через currentColor.
 */
export const ICON_NAMES = [
  'i-phone',
  'i-card',
  'i-plus2',
  'i-x',
  'i-cross',
  'i-capsule',
  'i-bottle',
  'i-jar',
  'i-spray',
  'i-tube',
  'i-drops',
  'i-search',
  'i-home',
  'i-filter',
  'i-grid',
  'i-pill',
  'i-cart',
  'i-user',
  'i-qr',
  'i-back',
  'i-chev',
  'i-check',
  'i-store',
  'i-gift',
  'i-box',
  'i-pin',
  'i-info',
  'i-out',
  'i-settings',
  'i-edit',
  'i-share',
  'i-locate',
  'i-mail',
  'i-bell',
  'i-pause',
  'i-play',
  'i-star',
  'i-heart',
  'i-car',
  'i-pharmacy',
  // Залитые варианты вкладок: активная вкладка показывает их (ТабБар).
  'i-home-fill',
  'i-pill-fill',
  'i-cart-fill',
  'i-box-fill',
] as const

export type IconName = (typeof ICON_NAMES)[number]

export function IconSprite() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <symbol id="i-phone" viewBox="0 0 24 24">
        <path
          d="M6.5 3.5h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.8 16.8 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-card" viewBox="0 0 24 24">
        <rect
          x="2.8"
          y="5"
          width="18.4"
          height="14"
          rx="2.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path
          d="M2.8 9.8h18.4M6 15h4"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-plus2" viewBox="0 0 24 24">
        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </symbol>
      <symbol id="i-x" viewBox="0 0 24 24">
        <path
          d="m6 6 12 12M18 6 6 18"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-cross" viewBox="0 0 24 24">
        <path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6z" fill="currentColor" />
      </symbol>
      <symbol id="i-capsule" viewBox="0 0 48 48">
        <g transform="rotate(45 24 24)">
          <rect x="14" y="6" width="20" height="36" rx="10" fill="#4DA283" />
          <path d="M14 24h20v8a10 10 0 0 1-10 10 10 10 0 0 1-10-10z" fill="#E7B75F" />
          <rect x="14" y="22.6" width="20" height="2.8" fill="rgba(0,0,0,.12)" />
        </g>
      </symbol>
      <symbol id="i-bottle" viewBox="0 0 48 48">
        <rect x="18" y="4" width="12" height="7" rx="2" fill="#7A8A83" />
        <path
          d="M15 13h18v6c2.5 1.6 4 4.3 4 7.2V40a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V26.2c0-2.9 1.5-5.6 4-7.2z"
          fill="#5C8FB8"
        />
        <rect x="14" y="27" width="20" height="11" rx="2" fill="#EDF3F7" />
      </symbol>
      <symbol id="i-jar" viewBox="0 0 48 48">
        <rect x="12" y="4" width="24" height="8" rx="3" fill="#B98A3E" />
        <rect x="9" y="12" width="30" height="32" rx="6" fill="#E7B75F" />
        <rect x="13" y="19" width="22" height="16" rx="2" fill="#FBF3E2" />
        <circle cx="20" cy="27" r="2.4" fill="#4DA283" />
        <circle cx="28" cy="27" r="2.4" fill="#4DA283" />
      </symbol>
      <symbol id="i-spray" viewBox="0 0 48 48">
        <path d="M20 4h8l4 6h-16z" fill="#7A8A83" />
        <rect x="21" y="1" width="6" height="5" rx="1.5" fill="#4DA283" />
        <rect x="16" y="12" width="16" height="32" rx="5" fill="#67A98C" />
        <rect x="18" y="21" width="12" height="12" rx="2" fill="#EAF5EF" />
      </symbol>
      <symbol id="i-tube" viewBox="0 0 48 48">
        <rect x="19" y="3" width="10" height="6" rx="2" fill="#7A8A83" />
        <path d="M15 11h18l3 26a4 4 0 0 1-4 4.5H16A4 4 0 0 1 12 37z" fill="#D98A80" />
        <rect x="15" y="20" width="18" height="12" rx="2" fill="#FBEFED" />
      </symbol>
      <symbol id="i-drops" viewBox="0 0 48 48">
        <rect x="20" y="2" width="8" height="8" rx="2.5" fill="#7A8A83" />
        <path d="M17 10h14v8l3 4v18a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V22l3-4z" fill="#8B7FC7" />
        <path d="M24 22c3 4.2 5 7 5 9.6a5 5 0 0 1-10 0c0-2.6 2-5.4 5-9.6z" fill="#EFEDF8" />
      </symbol>
      <symbol id="i-search" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="m16.5 16.5 4.5 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </symbol>
      <symbol id="i-home" viewBox="0 0 24 24">
        <path
          d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-filter" viewBox="0 0 24 24">
        <path
          d="M4 6h16M7 12h10M10 18h4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>
      {/* Каталог во вкладках: капсула линией, как остальные иконки панели. */}
      {/* Залитые варианты вкладок — как `.fill` у SF Symbols: тот же силуэт,
          внутренние линии — просветом, а не цветом фона, чтобы работать на
          любой подложке. */}
      <symbol id="i-home-fill" viewBox="0 0 24 24">
        <path
          d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
      </symbol>
      {/* Половинки капсулы с зазором на месте перемычки; контур расширен на
          полтолщины линии, чтобы силуэт совпадал с контурной иконкой. */}
      <symbol id="i-pill-fill" viewBox="0 0 24 24">
        <g transform="rotate(45 12 12)" fill="currentColor">
          <path d="M7.05 11.1V6.5a4.95 4.95 0 0 1 9.9 0v4.6z" />
          <path d="M7.05 12.9h9.9v4.6a4.95 4.95 0 0 1-9.9 0z" />
        </g>
      </symbol>
      <symbol id="i-cart-fill" viewBox="0 0 24 24">
        <path
          d="M3 4h2.5l2 12.5a1.5 1.5 0 0 0 1.5 1.3h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.1 8H21l-1.9 8.6a1.5 1.5 0 0 1-1.5 1.2H9a1.5 1.5 0 0 1-1.5-1.3z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <circle cx="10" cy="21" r="1.4" fill="currentColor" />
        <circle cx="17.5" cy="21" r="1.4" fill="currentColor" />
      </symbol>
      {/* Рёбра коробки — просветом через маску; к краям не доходят, иначе
          надрезали бы силуэт. */}
      <mask id="i-box-fill-cut" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#fff" />
        <path
          d="M5.3 8.2 12 12l6.7-3.8M12 12v7.7"
          fill="none"
          stroke="#000"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <symbol id="i-box-fill" viewBox="0 0 24 24">
        <path
          d="m12 3 8 4.5v9L12 21l-8-4.5v-9z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
          mask="url(#i-box-fill-cut)"
        />
      </symbol>
      <symbol id="i-pill" viewBox="0 0 24 24">
        <g transform="rotate(45 12 12)">
          <rect
            x="8"
            y="2.5"
            width="8"
            height="19"
            rx="4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
          />
          <path d="M8 12h8" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        </g>
      </symbol>
      <symbol id="i-grid" viewBox="0 0 24 24">
        <rect
          x="4"
          y="4"
          width="7"
          height="7"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="13"
          y="4"
          width="7"
          height="7"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="4"
          y="13"
          width="7"
          height="7"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="13"
          y="13"
          width="7"
          height="7"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
      </symbol>
      <symbol id="i-cart" viewBox="0 0 24 24">
        <path
          d="M3 4h2.5l2 12.5a1.5 1.5 0 0 0 1.5 1.3h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="10" cy="21" r="1.4" fill="currentColor" />
        <circle cx="17.5" cy="21" r="1.4" fill="currentColor" />
      </symbol>
      <symbol id="i-user" viewBox="0 0 24 24">
        <circle cx="12" cy="8.5" r="4" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <path
          d="M4.5 20a7.5 7.5 0 0 1 15 0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-qr" viewBox="0 0 24 24">
        <rect
          x="3"
          y="3"
          width="7"
          height="7"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="14"
          y="3"
          width="7"
          height="7"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="3"
          y="14"
          width="7"
          height="7"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path d="M14 14h3v3h-3zM18 18h3v3h-3z" fill="currentColor" />
      </symbol>
      <symbol id="i-back" viewBox="0 0 24 24">
        <path
          d="M14.5 5.5 8 12l6.5 6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-chev" viewBox="0 0 24 24">
        <path
          d="m9.5 5.5 6.5 6.5-6.5 6.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-check" viewBox="0 0 24 24">
        <path
          d="m4.5 12.5 5 5 10-11"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-store" viewBox="0 0 24 24">
        <path
          d="M4 9.5 5.5 4h13L20 9.5M4 9.5a2.7 2.7 0 0 0 5.3 0 2.7 2.7 0 0 0 5.4 0 2.7 2.7 0 0 0 5.3 0M5.5 12v8h13v-8"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-gift" viewBox="0 0 24 24">
        <rect
          x="4"
          y="9"
          width="16"
          height="11"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M12 9v11M4 13h16M12 9c-4.5 0-5.5-5-2.5-5S12 9 12 9zm0 0c4.5 0 5.5-5 2.5-5S12 9 12 9z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-box" viewBox="0 0 24 24">
        <path
          d="m12 3 8 4.5v9L12 21l-8-4.5v-9z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="m4 7.5 8 4.5 8-4.5M12 12v9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-pin" viewBox="0 0 24 24">
        <path
          d="M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <circle cx="12" cy="10" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </symbol>
      <symbol id="i-share" viewBox="0 0 24 24">
        {/* Три узла, связанные линиями: знакомый знак «поделиться» в Android и вебе. */}
        <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="M8.6 10.5l6.8-4M8.6 13.5l6.8 4" />
        </g>
      </symbol>
      <symbol id="i-mail" viewBox="0 0 24 24">
        <rect
          x="3.5"
          y="5.5"
          width="17"
          height="13"
          rx="2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="m4.5 7 7.5 6 7.5-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-locate" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="2.2" fill="currentColor" />
        <path
          d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-info" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 11v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="8" r="1.2" fill="currentColor" />
      </symbol>
      <symbol id="i-pause" viewBox="0 0 24 24">
        <rect x="6.5" y="5" width="3.6" height="14" rx="1.2" fill="currentColor" />
        <rect x="13.9" y="5" width="3.6" height="14" rx="1.2" fill="currentColor" />
      </symbol>
      <symbol id="i-play" viewBox="0 0 24 24">
        <path
          d="M8 5.6v12.8a1 1 0 0 0 1.5.86l10.2-6.4a1 1 0 0 0 0-1.72L9.5 4.74A1 1 0 0 0 8 5.6Z"
          fill="currentColor"
        />
      </symbol>
      {/* Заливку звезды задаёт место, где она стоит (`--icon-fill`): пустая — контур. */}
      <symbol id="i-star" viewBox="0 0 24 24">
        <path
          d="m12 3.6 2.6 5.27 5.82.85-4.21 4.1.99 5.8L12 16.88l-5.2 2.74.99-5.8-4.21-4.1 5.82-.85L12 3.6Z"
          style={{ fill: 'var(--icon-fill, none)' }}
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-bell" viewBox="0 0 24 24">
        <path
          d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15L6 16.5ZM10 20.5a2.2 2.2 0 0 0 4 0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-out" viewBox="0 0 24 24">
        <path
          d="M14 4H6a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 6 20h8M16 8l4 4-4 4M20 12H10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-settings" viewBox="0 0 24 24">
        <path
          d="M4 7h9M17 7h3M4 17h3M11 17h9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
        <circle cx="15" cy="7" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <circle cx="9" cy="17" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      {/* Машина курьера: легковая спереди, залитая — читается и в кружке 18px, и на карте.
          Контур Material Icons «directions_car» (Apache 2.0). */}
      <symbol id="i-car" viewBox="0 0 24 24">
        <path
          d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
          fill="currentColor"
        />
      </symbol>
      {/* Аптека: зелёный крест, как на вывесках аптек, — залитый, пара к машине курьера. */}
      <symbol id="i-pharmacy" viewBox="0 0 24 24">
        <path
          d="M9.8 3h4.4c.66 0 1.2.54 1.2 1.2v4.6H20c.66 0 1.2.54 1.2 1.2v4c0 .66-.54 1.2-1.2 1.2h-4.6v4.6c0 .66-.54 1.2-1.2 1.2H9.8c-.66 0-1.2-.54-1.2-1.2v-4.6H4c-.66 0-1.2-.54-1.2-1.2v-4c0-.66.54-1.2 1.2-1.2h4.6V4.2c0-.66.54-1.2 1.2-1.2z"
          fill="currentColor"
        />
      </symbol>
      {/* Избранное: контур; заливку включает --icon-fill у «сердца», которое нажато. */}
      <symbol id="i-heart" viewBox="0 0 24 24">
        <path
          d="M12 20.2s-7.6-4.6-8.9-9.6A4.9 4.9 0 0 1 12 6.4a4.9 4.9 0 0 1 8.9 4.2c-1.3 5-8.9 9.6-8.9 9.6Z"
          style={{ fill: 'var(--icon-fill, none)' }}
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-edit" viewBox="0 0 24 24">
        <path
          d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4zM13.5 6.5l4 4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
    </svg>
  )
}

export interface IconProps {
  name: IconName
  size?: number
  className?: string
}

export function Icon({ name, size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} className={className} aria-hidden="true">
      <use href={`#${name}`} />
    </svg>
  )
}
